export const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";

export async function api(path, opts = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    ...opts,
    headers: {
      ...(opts.body ? { "Content-Type": "application/json" } : {}),
      ...(opts.headers || {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    data = null;
  }
  if (!res.ok) {
    const detail = data?.detail;
    let msg = "Error inesperado";
    if (typeof detail === "string") msg = detail;
    else if (Array.isArray(detail)) msg = detail.map((e) => e?.msg || "").filter(Boolean).join(", ") || msg;
    throw new Error(msg);
  }
  return data;
}

export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("/")) return `${API_BASE}${url}`;
  return url;
}

export function scrollToId(id) {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
